import React, { FC } from 'react';
import SharedGenericPopUp from '../@shared/sharedGenericPopUp';
import { TGenericPopUpProps } from '../@shared/sharedGenericPopUp/types/genericPopUp.types';

const GenericPopUp: FC<TGenericPopUpProps> = (props) => {
  return (
    <SharedGenericPopUp {...props} />
  );
};

export default GenericPopUp;
